import 'babel-polyfill'
import Chart from 'chart.js';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import pieDefaults from './chart_pie_defaults.js';
import translation from '../messages.js';
import mixin from './tooltip_mixins.js';

Vue.use(VueI18n)

const i18n = new VueI18n({
    locale: current_language,
    messages: translation,
})

if(document.getElementById("BUYER_PROFILE_SMALL_SCALE_app")) {
    var app = new Vue({
        delimiters: ['[[', ']]'],
        el: '#BUYER_PROFILE_SMALL_SCALE_app'
    })
}

if(document.getElementById("chart_BUYER_PROFILE_SMALL_SCALE_0_app")) {
    var app = new Vue({
        i18n,
        mixins: [mixin],
        delimiters: ['[[', ']]'],
        el: '#chart_BUYER_PROFILE_SMALL_SCALE_0_app',
        data: {
            defaults: pieDefaults,
            chartData: null,
        },
        methods: {
            createChart(chartId) {
                const ctx = document.getElementById(chartId);
                const myChart = new Chart(ctx, {
                    type: 'doughnut',
                    data: this.chartData,
                    options: this.defaults.options,
                });
            },
        },
        mounted: function() {
            this.chartData = data_0;
            this.defaults.options.tooltips.callbacks = {};
            this.defaults.options.tooltips.callbacks.title = this.tooltipTitle;
            this.defaults.options.tooltips.callbacks.label = this.tooltipLabel;
            this.createChart('chart_BUYER_PROFILE_SMALL_SCALE_0');
        }
    })
}

if(document.getElementById("chart_BUYER_PROFILE_SMALL_SCALE_250k_app")) {
    var app = new Vue({
        i18n,
        mixins: [mixin],
        delimiters: ['[[', ']]'],
        el: '#chart_BUYER_PROFILE_SMALL_SCALE_250k_app',
        data: {
            defaults: pieDefaults,
            chartData: null,
        },
        methods: {
            createChart(chartId) {
                const ctx = document.getElementById(chartId);
                const myChart = new Chart(ctx, {
                    type: 'doughnut',
                    data: this.chartData,
                    options: this.defaults.options,
                });
            },
        },
        mounted: function() {
            this.chartData = data_250k;
            this.defaults.options.tooltips.callbacks = {};
            this.defaults.options.tooltips.callbacks.title = this.tooltipTitle;
            this.defaults.options.tooltips.callbacks.label = this.tooltipLabel;
            this.createChart('chart_BUYER_PROFILE_SMALL_SCALE_250k');
        }
    })
}

if(document.getElementById("chart_BUYER_PROFILE_SMALL_SCALE_1mil_app")) {
    var app = new Vue({
        i18n,
        mixins: [mixin],
        delimiters: ['[[', ']]'],
        el: '#chart_BUYER_PROFILE_SMALL_SCALE_1mil_app',
        data: {
            defaults: pieDefaults,
            chartData: null,
        },
        methods: {
            createChart(chartId) {
                const ctx = document.getElementById(chartId);
                const myChart = new Chart(ctx, {
                    type: 'doughnut',
                    data: this.chartData,
                    options: this.defaults.options,
                });
            },
        },
        mounted: function() {
            this.chartData = data_1mil;
            this.defaults.options.tooltips.callbacks = {};
            this.defaults.options.tooltips.callbacks.title = this.tooltipTitle;
            this.defaults.options.tooltips.callbacks.label = this.tooltipLabel;
            this.createChart('chart_BUYER_PROFILE_SMALL_SCALE_1mil');
        }
    })
}

if(document.getElementById("chart_BUYER_PROFILE_SMALL_SCALE_3mil_app")) {
    var app = new Vue({
        i18n,
        mixins: [mixin],
        delimiters: ['[[', ']]'],
        el: '#chart_BUYER_PROFILE_SMALL_SCALE_3mil_app',
        data: {
            defaults: pieDefaults,
            chartData: null,
        },
        methods: {
            createChart(chartId) {
                const ctx = document.getElementById(chartId);
                const myChart = new Chart(ctx, {
                    type: 'doughnut',
                    data: this.chartData,
                    options: this.defaults.options,
                });
            },
        },
        mounted: function() {
            this.chartData = data_3mil;
            this.defaults.options.tooltips.callbacks = {};
            this.defaults.options.tooltips.callbacks.title = this.tooltipTitle;
            this.defaults.options.tooltips.callbacks.label = this.tooltipLabel;
            this.createChart('chart_BUYER_PROFILE_SMALL_SCALE_3mil');
        }
    })
}

if(document.getElementById("popup_BUYER_PROFILE_SMALL_SCALE_app")) {
    var app = new Vue({
        delimiters: ['[[', ']]'],
        el: '#popup_BUYER_PROFILE_SMALL_SCALE_app',
        data: {
            showRawData: false,
        },
        methods: {
            toggleRawData: function() {
                this.showRawData = !this.showRawData;
            }
        }
    })
}